// extracted by mini-css-extract-plugin
export var currentPage = "Pagination-module--currentPage--16b33";
export var numberBox = "Pagination-module--numberBox--52560";
export var pageNumbers = "Pagination-module--pageNumbers--c3f4b";